import React from 'react'
import './Community.css'

function Community() {
    return (
        <div className="community-container">
            <h1> community</h1>
        </div>
    )
}

export default Community
